module.exports = __webpack_public_path__ + "img/office-follow.06de0064.jpg";